import { Inject, Injectable } from '@angular/core';

@Injectable({
    providedIn: 'root'
})
export class QueryStringParamService {
    constructor(@Inject('Window') $window: Window) {
        this.$window = $window;
    }
    $window;
    /**
     * Get a single querystring parameter from the querystring (or from the provided search string)
     * @param name the name of the param
     * @param search optional search string to use instead of the url
     */
    getQueryStringParam(name: string, search?: string): any {
        return this.getQueryStringParams(search)[name.toLowerCase()] || null;
    }

    /**
     * Get an object with every querystring parameter available.
     * @param search optional search string to use instead of the url
     */
    getQueryStringParams(search: string = this.$window.location.search) {
        const searchPairs = search.replace('?', '').replace(/%20/g, ' ').split('&');
        return searchPairs.reduce((acc: any, item: string): any => {
            item = item.replace('%22=%22', '%22%3D%22'); // prevent "=" from splitting
            const keyVal = item.split('=');
            let key = keyVal[0];
            let val = acc[key];

            if (key) {
                key = key.toLowerCase();
            }
            if (val !== undefined && val !== null && !Array.isArray(val)) {
                acc[key] = val = [acc[key]];
            }

            if (keyVal.length > 1) {
                if (Array.isArray(val)) {
                    val.push(keyVal[1]);
                } else {
                    acc[key] = keyVal[1];
                }
            } else {
                if (Array.isArray(val)) {
                    val.push(true);
                } else {
                    acc[key] = true;
                }
            }

            return acc;
        }, {});
    }
}
